import React from 'react';
import './PrivacyPage.scss';

interface PrivacyPageProps {
  menuOpen: boolean;
}

const PrivacyPage: React.FC<PrivacyPageProps> = ({ menuOpen }) => {
  return (
    <div className={`privacy-page ${menuOpen ? 'menu-open' : ''}`}>
      <div className="privacy-page__hero">
        <div className="privacy-page__content">
          <h1 className="privacy-page__title">PRIVACY POLICY</h1>
          
          <div className="privacy-page__text-content">
            <p className="privacy-page__updated">Last Updated: May 2026</p>

            <section className="privacy-page__section">
              <h2>Introduction</h2>
              <p>
                Stage Door Weddings ("we", "our", or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website or use our services.
              </p>
            </section>

            <section className="privacy-page__section">
              <h2>Information We Collect</h2>
              <h3>Personal Information</h3>
              <p>We may collect personal information that you voluntarily provide to us when you:</p>
              <ul>
                <li>Fill out our contact form</li>
                <li>Request a brochure or quote</li>
                <li>Book our videography services</li>
                <li>Subscribe to our newsletter</li>
                <li>Communicate with us via email or phone</li>
              </ul>
              <p>This information may include:</p>
              <ul>
                <li>Name and contact details (email address, phone number, postal address)</li>
                <li>Wedding date and venue information</li>
                <li>Payment and billing information</li>
                <li>Any other information you choose to provide</li>
              </ul>

              <h3>Automatically Collected Information</h3>
              <p>When you visit our website, we may automatically collect certain information about your device, including:</p>
              <ul>
                <li>IP address</li>
                <li>Browser type and version</li>
                <li>Pages visited and time spent on pages</li>
                <li>Referring website addresses</li>
                <li>Operating system</li>
              </ul>
            </section>

            <section className="privacy-page__section">
              <h2>How We Use Your Information</h2>
              <p>We use the information we collect to:</p>
              <ul>
                <li>Provide, operate, and maintain our wedding videography services</li>
                <li>Process your bookings and manage our relationship with you</li>
                <li>Send you information about our services, including quotes and brochures</li>
                <li>Respond to your enquiries and provide customer support</li>
                <li>Improve our website and services</li>
                <li>Send you marketing communications (with your consent)</li>
                <li>Comply with legal obligations</li>
              </ul>
            </section>

            <section className="privacy-page__section">
              <h2>Sharing Your Information</h2>
              <p>We do not sell, trade, or rent your personal information to third parties. We may share your information with:</p>
              <ul>
                <li><strong>Service Providers:</strong> Third-party vendors who assist us in operating our website and conducting our business (e.g., payment processors, email service providers)</li>
                <li><strong>Legal Requirements:</strong> When required by law or to protect our rights and safety</li>
                <li><strong>Business Transfers:</strong> In connection with any merger, sale of company assets, or acquisition</li>
              </ul>
            </section>

            <section className="privacy-page__section">
              <h2>Cookies and Tracking Technologies</h2>
              <p>
                We use cookies and similar tracking technologies to track activity on our website and hold certain information. Cookies are files with a small amount of data which may include an anonymous unique identifier.
              </p>
              <p>You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. However, if you do not accept cookies, you may not be able to use some portions of our website.</p>
            </section>

            <section className="privacy-page__section">
              <h2>Data Security</h2>
              <p>
                We implement appropriate technical and organisational security measures to protect your personal information. However, no method of transmission over the Internet or electronic storage is 100% secure, and we cannot guarantee absolute security.
              </p>
            </section>

            <section className="privacy-page__section">
              <h2>Your Rights</h2>
              <p>Under data protection law, you have rights including:</p>
              <ul>
                <li><strong>Access:</strong> Request copies of your personal data</li>
                <li><strong>Rectification:</strong> Request correction of inaccurate data</li>
                <li><strong>Erasure:</strong> Request deletion of your personal data</li>
                <li><strong>Restriction:</strong> Request restriction of processing your data</li>
                <li><strong>Objection:</strong> Object to our processing of your data</li>
                <li><strong>Portability:</strong> Request transfer of your data to another organisation</li>
              </ul>
              <p>To exercise these rights, please contact us at bellkeir@gmail.com</p>
            </section>

            <section className="privacy-page__section">
              <h2>Data Retention</h2>
              <p>
                We retain your personal information only for as long as necessary to fulfil the purposes outlined in this Privacy Policy, unless a longer retention period is required or permitted by law.
              </p>
            </section>

            <section className="privacy-page__section">
              <h2>Children's Privacy</h2>
              <p>
                Our services are not directed to individuals under the age of 18. We do not knowingly collect personal information from children under 18.
              </p>
            </section>

            <section className="privacy-page__section">
              <h2>Changes to This Privacy Policy</h2>
              <p>
                We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last Updated" date.
              </p>
            </section>

            <section className="privacy-page__section">
              <h2>Contact Us</h2>
              <p>If you have any questions about this Privacy Policy, please contact us:</p>
              <ul>
                <li>Email: bellkeir@gmail.com</li>
                <li>Through our contact form on this website</li>
              </ul>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPage;
